import analyticsEvent from 'services/analytic/analytic-service';

export const sendAnalyticsEvent = ({ gaLabel = '' } = {}) => {
  analyticsEvent({
    gaAction: 'Product Page - Ways to pay',
    gaLabel,
  });
};

export const userHasNonCreditAccount = (): boolean => {
  const user = window?.universal_variable?.user;
  const creditAccount = '1';

  return !user || (user.cva && user.cva !== creditAccount) || false;
};

const userHasCashAccount = (): boolean => window?.universal_variable?.user?.cva === '2';

export const userIsBnplEligible = (): boolean =>
  userHasCashAccount() || window?.universal_variable?.user?.bnplEligibility !== 'false';
